import React from "react";
import { usePosts } from "../Hooks/usePosts";
import useToggle from "../Hooks/useToggle";
import Drawer from "../components/Mobile/Drawer";
import Footer from "../components/Partials/Footers/HomeOne/Footer";
import BackToTop from "../components/Helpers/BackToTop";
import { useLocation } from "react-router-dom";
import { capitalizeFirstLetter } from "../utils/utils";
import { usePostsByCategory } from "../Hooks/usePostsByCategory";
import { Link } from "react-router-dom";

const Category = () => {
  const { data: posts, isLoading } = usePosts();
  const [drawer, setDrawer] = useToggle(false);
  const location = useLocation();

  // Extract category from URL path (e.g., /category/sports -> sports)
  const pathSegments = location.pathname.split("/");
  const categoryFromUrl = decodeURIComponent(
    pathSegments[pathSegments.length - 1]
  );
  const categoryName = capitalizeFirstLetter(categoryFromUrl);
  const { data: filteredPosts, isLoading: categoryLoading } =
    usePostsByCategory([categoryFromUrl]);
  // Filter posts by category

  console.log("Category posts:", filteredPosts);

  // Show loading state when either posts or category data is loading
  if (isLoading || categoryLoading) {
    return (
      <>
        <Drawer drawer={drawer} action={setDrawer.toggle} />
        <div className="loading-container">
          <div className="loading-content">
            <div className="loading-spinner">
              <div className="spinner"></div>
            </div>
            <p>Duke ngarkuar lajmet...</p>
          </div>
        </div>
        <Footer />
        <BackToTop />
      </>
    );
  }

  // Show error state if no posts are available
  if (!posts || posts.length === 0) {
    return (
      <>
        <Drawer drawer={drawer} action={setDrawer.toggle} />
        <div className="error-container">
          <div className="error-content">
            <div className="error-icon">
              <i className="fas fa-exclamation-triangle"></i>
            </div>
            <h2>Gabim në ngarkim</h2>
            <p>
              Nuk ka lajme të disponueshme në këtë moment. Ju lutem provoni më
              vonë.
            </p>
          </div>
        </div>
        <Footer />
        <BackToTop />
      </>
    );
  }

  return (
    <>
      <Drawer drawer={drawer} action={setDrawer.toggle} />

      {/* Category Header Section */}
      <section className="category-header-section">
        <div className="container">
          <div className="section-header">
            <h1 className="section-title">{categoryName}</h1>
            <p className="section-subtitle">
              Lajmet më të fundit nga {categoryName.toLowerCase()}
            </p>
          </div>
        </div>
      </section>

      {/* Category Content */}
      <section className="category-content-section">
        <div className="container">
          {filteredPosts && filteredPosts.length > 0 ? (
            <>
              {/* Featured Post */}
              <div className="featured-post-section">
                <div className="row">
                  <div className="col-lg-8">
                    <article className="featured-post">
                      <Link to={`/news/${filteredPosts[0].id}`}>
                        <div className="featured-post-image">
                          <img
                            src={filteredPosts[0].image_url}
                            alt={filteredPosts[0].title}
                          />
                        </div>
                        <div className="featured-post-content">
                          <span className="featured-category">
                            {categoryName}
                          </span>
                          <h3 className="post-title">
                            {filteredPosts[0].title}
                          </h3>
                          <p className="post-excerpt">
                            {filteredPosts[0].excerpt}
                          </p>
                          <div className="post-meta">
                            <span className="post-date">
                              {new Date(
                                filteredPosts[0].created_at
                              ).toLocaleDateString("sq-AL")}
                            </span>
                          
                          </div>
                        </div>
                      </Link>
                    </article>
                  </div>

                  {/* Sidebar with categories */}
                  <div className="col-lg-4">
                    <div className="category-sidebar">
                      {/* Related Categories */}
                      <div className="sidebar-section">
                        <h3 className="sidebar-title">Kategoritë e tjera</h3>
                        <div className="category-links">
                          {[
                            "Lajme",
                            "Politikë",
                            "Ekonomi",
                            "Sport",
                            "Teknologji",
                            "Shëndetësi",
                            "Kulturë",
                          ].map((category) => (
                            <Link
                              key={category}
                              to={`/category/${category.toLowerCase()}`}
                              className="category-link"
                            >
                              {category}
                            </Link>
                          ))}
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>

              {/* Other News Cards Section */}
              {filteredPosts.length > 1 && (
                <div className="other-news-section">
                  <div className="row">
                    <div className="col-12">
                      <h3 className="section-title">
                        Lajme të tjera nga {categoryName}
                      </h3>
                    </div>
                  </div>
                  <div className="row">
                    {filteredPosts.slice(1).map((post) => (
                      <div key={post.id} className="col-lg-4 col-md-6 mb-4">
                        <article className="news-card">
                          <Link to={`/news/${post.id}`}>
                            <div className="news-card-image">
                              <img src={post.image_url} alt={post.title} />
                            </div>
                            <div className="news-card-content">
                              <span className="news-card-category">
                                {categoryName}
                              </span>
                              <h4 className="news-card-title">{post.title}</h4>
                              <p className="news-card-excerpt">
                                {post.excerpt}
                              </p>
                              <div className="news-card-meta">
                                <span className="news-card-date">
                                  {new Date(post.created_at).toLocaleDateString(
                                    "sq-AL"
                                  )}
                                </span>
                                
                              </div>
                            </div>
                          </Link>
                        </article>
                      </div>
                    ))}
                  </div>
                </div>
              )}
            </>
          ) : (
            <div className="no-posts-message">
              <h3>Nuk ka lajme të disponueshme për këtë kategori.</h3>
              <p>Ju lutem kontrolloni më vonë për lajme të reja.</p>
            </div>
          )}
        </div>
      </section>

      <Footer />
      <BackToTop />
    </>
  );
};

export default Category;
